import React, { FC } from 'react'

import TranslateIcon from '../../../Icons/TranslateIcon'
import { TranslationState } from '../../../../utils/types/UgcTranslations'

import styles from '../../../../styles/SingleProductReviewsSection.module.less'

interface IButtonProps {
  toggleTranslation?: () => void
  userPrompt?: string
  translationState?: TranslationState
}

/* There are three components to translate user generated content (UGC):
 *  - TranslateWrapper
 *  - TranslatableText
 *  - TranslateButton
 *
 * These components are meant for translating an arbitrary number of strings (potentially with
 * other components between them) with a single button. If you only need to translate a single
 * string with each button, and the button can go directly underneath the string, use component
 * TranslatableContent instead.
 *
 * HOW TO USE:
 *
 * Before:
 *
 * <div>
 *  {stringToTranslate1}
 *  ...
 *  {stringToTranslateN}
 * </div>
 *
 * After:
 *
 * <div>
 *  <TranslateWrapper sourceLang={'fi'}>
 *    <TranslatableText originalText={stringToTranslate1} />
 *    ...
 *    <TranslatableText originalText={stringToTranslateN} />
 *    <TranslateButton />
 *  <TranslateWrapper />
 * </div>
 *
 */

const TranslateButton: FC<IButtonProps> = (props) => {
  const { toggleTranslation, userPrompt, translationState } = props

  if (!toggleTranslation || !userPrompt || !translationState) {
    return null // Button not initialized yet
  }
  if (translationState === 'not required' || translationState === 'error') {
    return null // No need for button
  }

  const handleTranslateClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation() // Stops click from following link of parent component
    toggleTranslation()
  }

  return (
    <div className="margin-top-spacer-double">
      <span className={styles.container}>
        <span className={styles.icon}>
          <TranslateIcon />
        </span>
        <button
          className={styles.prompt}
          onClick={handleTranslateClick}
          type="button"
        >
          <strong>{userPrompt}</strong>
        </button>
      </span>
    </div>
  )
}

export default TranslateButton
